<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-row class="mb-3">
          <v-col>
            <BreadCrumbs
              v-model="deviceGroupId"
              :modelId="modelId"
              :serialNo="serialNo"
              @click_breadCrumbs="selectedGroupChange"
              @click_breadCrumbsDevice="selectedDeviceChange"
            />
            <v-divider />
          </v-col>
        </v-row>
        <v-card outlined>
          <v-row>
            <v-col class="mt-0 mb-0">
              <v-card-text v-if="isDevice">
                {{ deviceName }}
              </v-card-text>
            </v-col>
            <v-col class="mt-0 mb-0">
              <v-card-actions class="float-right">
                <v-btn @click="downloadCsvAllAlert" color="primary" depressed>
                  <custom-icon type="download" :size="15" class="mr-3" :colors="['#FFFFFF']"></custom-icon>
                  <custom-icon type="alarmOutput" :size="30" :colors="['#FFFFFF']"></custom-icon>
                </v-btn>
                <v-btn @click="downloadCsvDriveData" color="primary" depressed>
                  <custom-icon type="download" :size="15" class="mr-3" :colors="['#FFFFFF']"></custom-icon>
                  <custom-icon type="trendGraph" :size="30" :colors="['#FFFFFF', '#FFFFFF', '#FFFFFF']"> </custom-icon>
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="mt-0 mb-0">
              <v-card-text v-if="optionalInfo">
                {{ $t(`customerSMachineNo`) }}<span class="ml-5">{{ optionalInfo }}</span>
              </v-card-text>
            </v-col>
            <v-col class="mt-0 mb-0">
              <v-card-actions class="float-right">
                <v-btn
                  @click="filterEventLevelE"
                  :color="searchObject.eventLevelE ? 'primary' : 'grey lighten-2'"
                  :dark="searchObject.eventLevelE"
                  class="mx-0 px-0 rounded-r-0"
                  depressed
                  >E</v-btn
                >
                <v-btn
                  @click="filterEventLevelC"
                  :color="searchObject.eventLevelC ? 'primary' : 'grey lighten-2'"
                  :dark="searchObject.eventLevelC"
                  class="mx-0 px-0 rounded-l-0 rounded-r-0"
                  depressed
                  >C</v-btn
                >
                <v-btn
                  @click="filterEventLevelM"
                  :color="searchObject.eventLevelM ? 'primary' : 'grey lighten-2'"
                  :dark="searchObject.eventLevelM"
                  class="mx-0 px-0 rounded-l-0"
                  depressed
                  >M</v-btn
                >
                <v-btn
                  @click="filterRepaired"
                  :color="searchObject.repaired ? 'primary' : 'grey lighten-2'"
                  :dark="searchObject.repaired"
                  depressed
                  ><v-icon>mdi-reload</v-icon></v-btn
                >
              </v-card-actions>
            </v-col>
          </v-row>
          <v-card-text>
            <v-data-table
              height="70vh"
              fixed-header
              dense
              :headers="headers"
              :items="items"
              :items-per-page="100"
              hide-default-footer
              item-key="id"
              @click:row="clickRow"
              :item-class="alermHighlight"
              :loading="loading"
              class="v-data-table-outlined"
            >
              <template v-slot:[`item.name_locale`]="{ item }">
                <v-img
                  v-if="item.event_level === '1'"
                  src="@/assets/maintenance.png"
                  width="20"
                  height="20"
                  contain
                  class="d-inline-block"
                ></v-img>
                <v-img
                  v-if="item.event_level === '2'"
                  src="@/assets/caution.png"
                  width="20"
                  height="20"
                  contain
                  class="d-inline-block mx-0 px-0"
                ></v-img>
                <v-img
                  v-if="item.event_level === '3'"
                  src="@/assets/emergency.png"
                  width="20"
                  height="20"
                  contain
                  class="d-inline-block"
                ></v-img>
                {{ item[`name_locale${localeId}`] }}
              </template>
              <template v-slot:[`item.device_name_locale`]="{ item }">
                <router-link
                  :to="{ name: 'CompressorInfo', params: { model_id: item.model_id, serial_no: item.serial_no } }"
                >
                  {{ item[`device_name_locale${localeId}`] }}
                </router-link>
              </template>
              <template v-slot:[`item.device_group_name_locale`]="{ item }">
                <router-link :to="{ name: 'HomeConsumer', params: { device_group_id: item.device_group_id } }">
                  {{ item[`device_group_name_locale${localeId}`] }}
                </router-link>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import CustomIcon from '@/components/CustomIcon.vue';
  import BreadCrumbs from '@/components/BreadCrumbs.vue';
  import csv from '@/utils/csv';
  import { alermHistoryMixin } from '@/utils/dashbord.js';

  export default {
    title() {
      return this.$t(this.$route.meta.title);
    },
    name: 'Table',
    components: {
      CustomIcon,
      BreadCrumbs,
    },
    mixins: [csv, alermHistoryMixin()],
    data: () => ({
      // searchObject: {
      //   eventLevelM: true,
      //   eventLevelC: true,
      //   eventLevelE: true,
      //   repaired: false,
      // },
      // selected: null, // 行選択中のアイテム
      // deviceName: null,
      // optionalInfo: null,
      // deviceGroupId: null,
      // modelId: null,
      // serialNo: null,
      // groupId: null,
      // compressors: null,
      // items: [],
      // loading: false,
      // timeoutObj: null,
    }),
    filters: {},
    computed: {
      repairedButtonColor() {
        // 修復済みがONの場合、青色
        return this.searchObject.repaired ? 'primary' : '';
      },
      eventLevelMButtonColor() {
        // MがONの場合、青色
        return this.searchObject.eventLevelM ? 'primary' : '';
      },
      eventLevelCButtonColor() {
        // CがONの場合、青色
        return this.searchObject.eventLevelC ? 'primary' : '';
      },
      eventLevelEButtonColor() {
        // EがONの場合、青色
        return this.searchObject.eventLevelE ? 'primary' : '';
      },
      localeId() {
        switch (this.$i18n.locale) {
          case 'en':
            return 1;
          case 'ja':
            return 2;
          case 'zh':
            return 3;
        }
        return 2;
      },
    },
    async created() {
      // 入力パラメータを保持
      this.modelId = this.$route.params.model_id;
      this.serialNo = this.$route.params.serial_no;
      this.deviceGroupId = this.$route.params.device_group_id;
      this.groupId = this.$route.params.group_id;
      this.compressors = await this.getGroups(this.deviceGroupId, this.groupId);

      this.getAlermHistory(true);
    },
    methods: {
      async downloadCsvAllAlert() {
        // 一覧出力
        this.$store.commit('loading/start_loading');

        console.info('API開始');
        const [url, params] = await this.setQueryParams();

        // 一年前からのアラームを取得
        const fromDate = this.$moment().add(-1, 'y').startOf('day').format('YYYY-MM-DD HH:mm:ss.SSSSSSS');
        params.event_time_from = fromDate;

        // アラームを取得
        this.apiRequest(url, 'GET', params)
          .then((response) => {
            let items = [];

            const header = [
              this.$t('alarmName'),
              this.$t('serialNo'),
              this.$t('model'),
              this.$t('customerName'),
              this.$t('customerSMachineNo'),
              this.$t('value'),
              this.$t('time'),
              this.$t('localTime'),
            ];

            items.push(header);

            response.forEach((el) => {
              let lineData = [];

              lineData.push(el[`name_locale${this.localeId}`]);
              lineData.push(el[`device_name_locale${this.localeId}`]);
              lineData.push(el.device_optional_info_1);
              lineData.push(el[`device_group_name_locale${this.localeId}`]);
              lineData.push(el.device_optional_info2);
              lineData.push(this.valueLabel(el.event_level, el.incident_class));
              lineData.push(this.browserLocalTime(el.event_time));
              lineData.push(this.localTime(el.event_time, el.device_time_zone));

              items.push(lineData);
            });
            const fileName = `${this.$moment().format('YYYYMMDD')}.csv`;

            this.downloadCsv(fileName, items);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            console.info('API完了');
            this.$store.commit('loading/end_loading');
          });
      },
      async downloadCsvDriveData() {
        // 運転データ出力 仕様
        // ・日時はタイムゾーンで変換
        // ・センサーIDが「sn 」で始まるものは対象外
        //    snで始まるデータ センサーノーマル 5秒間隔を2分平均
        //    saで始まるデータ センサーアラーム発生時のデータ
        // ・名称が「予備」は対象外
        // ・名称が「異常 」で始まるものは空白に置換
        // ・3分間分を取得して120件を取得(データ記録にラグがあるため1分間のバッファ)
        // ・「Ｍ：メンテナンス」アラートの詳細データは取得しない
        // ・ 小数点以下1桁まで表示→ 電流・負荷状態・補機状態・運転時間・総運転回数
        // ・16進数4桁に変換→名称に(Hex)が含まれるもの

        // 行選択されていなければ終了
        if (this.selected === null) {
          return;
        }

        this.$store.commit('loading/start_loading');
        try {
          // csvデータ
          let items = [];

          // センサを取得
          const res1 = await this.apiRequest('/v1/master-info/sensors', 'GET', {
            model_id: this.selected.model_id,
            serial_no: this.selected.serial_no,
            sort: 'sensor_id',
          });

          let header = [];
          let sensorList = [];
          let mappingLabels = [];
          let convertLabels = [];
          header.push(this.$t('dateTime'));

          res1.forEach((el) => {
            // sensor_idが「sn 」で始まるものは除外 名称が予備も対象外
            // snで始まるデータ センサーノーマル 5秒間隔を2分平均
            // saで始まるデータ センサーアラーム発生時のデータ
            if (!el.sensor_id.startsWith('sn_') || !el.name_locale2 === '予備') {
              //if(!el.name_locale2.startsWith('異常 ')){
              // 名称が「異常 」で始まるものは空白に置換""
              const label = el[`name_locale${this.localeId}`]
                .replace('異常 ', '')
                .replace('Abnl ', '')
                .replace('异常 ', '');
              if (header.indexOf(label) < 0) {
                header.push(label);
              }
              // 運転データ取得用のパラメータを生成
              sensorList.push({
                model_id: this.selected.model_id,
                serial_no: this.selected.serial_no,
                sensor_id: el.sensor_id,
              });

              mappingLabels[el.sensor_id] = label;
              // 値変換用のトリガーに日本語のラベルを保持しておく
              convertLabels[el.sensor_id] = el.name_locale2.replace('異常 ', '');
            }
          });
          items.push(header);

          // 「Ｍ：メンテナンス」アラートの詳細データは取得しない
          if (this.selected.event_level !== '1') {
            // 発生時刻から直近2分間だが（サーバサイドでもデータ記録にタイミングのズレがあるためにバッファ1分間を追加、取得後120件に整形する)
            const toDate = this.$moment(this.selected.event_time).format('YYYY-MM-DD HH:mm:ss.SSSSSSS');
            const fromDate = this.$moment(this.selected.event_time).add(-3, 'm').format('YYYY-MM-DD HH:mm:ss.SSSSSSS');
            const res2 = await this.apiRequest('/v1/sensor-data-file-mgt/getSensorData', 'POST', {
              get_class: '1',
              measure_time_from: fromDate,
              measure_time_to: toDate,
              sensor_list: sensorList,
              iso8601_datetime_format: true,
            });

            // CSV用に加工
            let dataList = [];
            res2[0].timeList.forEach((timeData) => {
              const label = mappingLabels[timeData.sensorId];
              const checkLabel = convertLabels[timeData.sensorId];
              // 秒単位で計測データをまとめる
              timeData.dataList.forEach((data) => {
                const measureTime = data.measureTime;
                console.log(`time: ${data.measureTime} → ${measureTime}`);
                if (dataList[measureTime] === undefined) {
                  dataList[measureTime] = [];
                }
                let value = data.data;
                // 単位が異なるので10倍にする
                if (this.$i18n.locale === 'en' && checkLabel.indexOf('圧力') >= 0) {
                  value *= 10;
                }
                if (
                  checkLabel === '電流' ||
                  checkLabel === '負荷状態' ||
                  checkLabel === '補機状態' ||
                  checkLabel === '運転時間' ||
                  checkLabel === '総運転回数'
                ) {
                  value = '' + parseFloat(value).toFixed(1);
                }
                if (checkLabel.includes('(Hex)')) {
                  value = Number(value).toString(16);
                  value = ('0000' + value).slice(-4);
                }
                dataList[measureTime][label] = value;
              });
            });
            // measureTimeでソート
            const keys = Object.keys(dataList);
            keys.sort();

            const csvDataList = keys.map((key) => {
              let lineData = [];
              // 先頭は日付
              lineData.push(this.localTime(key, this.selected.device_time_zone));
              const data = dataList[key];
              // ヘッダと同じ並びで出力
              header
                .filter((el) => el !== '日時' && el !== 'Date time')
                .forEach((el) => {
                  const value = data[el];
                  lineData.push(value !== undefined ? value : '');
                });
              return lineData;
            });
            items = items.concat(csvDataList.slice(-120));
          }

          const fileName = `${this.$moment().format('YYYYMMDD')}-${this.selected.model_id}-${
            this.selected.serial_no
          }.csv`;
          this.downloadCsv(fileName, items);
        } catch (error) {
          console.error(error);
        } finally {
          console.info('API完了');
          this.$store.commit('loading/end_loading');
        }
      },
    },
  };
</script>
<style scoped></style>
<style>
  /** ECMのハイライト */
  .alerm-history-highlight-E,
  .alerm-history-highlight-E .v-data-table__mobile-row {
    background-color: #f4d1d4;
  }
  .alerm-history-highlight-C,
  .alerm-history-highlight-C .v-data-table__mobile-row {
    background-color: #fee4d3;
  }
  /* .alerm-history-highlight-M{} */
  /** 行選択時のハイライト */
  .alerm-history-selected {
    background-color: #d1e1f1;
  }
</style>
